export default "__VITE_ASSET__Crl6Shma__"